let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f4eLg")).then(() => parcelRequire('9Muer'));